import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import type { SettingsItem } from './settings.registry';

/**
 * Settings detail — a Back affordance over one section. Its own route
 * (/portal/settings/:key) so browser back / history / deep-linking work.
 */
export function SettingsDetail({ item }: { item: SettingsItem }) {
  const Section = item.Component;

  return (
    <div>
      <Link
        to="/portal/settings"
        className="group inline-flex items-center gap-2 text-sm text-foreground hover:opacity-80 transition-opacity mb-6"
      >
        <ArrowLeft className="w-4 h-4 transition-transform md:group-hover:-translate-x-0.5" />
        Back to settings
      </Link>

      <div className="mb-4">
        <h1 className="text-xl md:text-2xl font-semibold">{item.label}</h1>
      </div>

      <Section />
    </div>
  );
}

export default SettingsDetail;
